// extracted by mini-css-extract-plugin
export default {"open-call-note-history":"CallNoteHistory_open-call-note-history__Ur0ks"};